import { mergeDeepRight } from "ramda";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { ModelTemplate } from "../metadata/types";
import {
  onUploadFormChange,
  resetUpload,
  uploadFinancialDocument
} from "./actions";
import { EntityDropdownOption } from "./types";

export enum STATES {
  ERROR = "error",
  INITIAL = "initial",
  LOADING = "loading",
  SUCCESS = "success"
}

export interface InitialStatus {
  status: STATES.INITIAL;
  message: string;
}

export interface LoadingStatus {
  status: STATES.LOADING;
  message: string;
}

export interface SuccessStatus {
  status: STATES.SUCCESS;
  message: string;
}

export interface ErrorStatus {
  status: STATES.ERROR;
  message: string;
}

export type DocumentUploadFormStatus =
  | InitialStatus
  | LoadingStatus
  | SuccessStatus
  | ErrorStatus;

export interface DocumentUploadFormState {
  file: File | null;
  spreadName: string;
  firstPeriodDate: Date | null;
  secondPeriodDate: Date | null;
  priority: boolean;
  entity: EntityDropdownOption | null;
  numPeriods: number;
  template: ModelTemplate | null;
  auditMethod: string | null;
  statementType: string;
  statementClassification: string;
}

export interface DocumentUploadState {
  form: DocumentUploadFormState;
  request: DocumentUploadFormStatus;
}

export const initialFormState = {
  file: null,
  spreadName: "",
  firstPeriodDate: null,
  secondPeriodDate: null,
  priority: false,
  entity: null,
  numPeriods: 1,
  template: null,
  auditMethod: null,
  statementType: "Annual",
  statementClassification: "",
  consolidation: "",
  periods: 12
};

const documentUploadReducer = reducerWithInitialState<
  Readonly<DocumentUploadState>
>({
  form: initialFormState,
  request: {
    status: STATES.INITIAL,
    message: ""
  }
})
  .case(resetUpload, (state, _) => ({
    form: initialFormState,
    request: {
      status: STATES.INITIAL,
      message: ""
    }
  }))
  .case(uploadFinancialDocument.async.done, (state, _) =>
    mergeDeepRight(state, {
      form: initialFormState,
      request: { status: STATES.SUCCESS }
    })
  )
  .case(uploadFinancialDocument.async.started, (state, _) =>
    mergeDeepRight(state, { request: { status: STATES.LOADING } })
  )
  .case(uploadFinancialDocument.async.failed, (state, { error }) =>
    mergeDeepRight(state, {
      request: { status: STATES.ERROR, message: error.message }
    })
  )
  .case(onUploadFormChange, (state, payload) =>
    mergeDeepRight(state, {
      form: payload,
      request: { status: STATES.INITIAL }
    })
  );

export default documentUploadReducer;



// WEBPACK FOOTER //
// ./src/documentUpload/reducer.ts